import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { theme } from '../../../theme/theme';
import { ProjectCard } from '../../project/common/ProjectCard';

const useInspectionsProjectsClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: 10,
        '& > span': {
            color: theme.colors.neutral[1],
            ...theme.typography.content.text,
        },
    },
});

/**
 * List projects of a given asset/plan.
 */
export const Projects = () => {
    const classes = useInspectionsProjectsClasses();
    const { t } = usePrefixTranslation('asset', { asset: 'drawer.Projects' });
    const dispatch = useTypedDispatch();
    const { asset, plan, allProjects } = useTypedSelector(state => ({
        asset: state.asset,
        plan: state.plan,
        allProjects: state.planProjects.all,
    }));

    React.useEffect(() => void (plan.plan && dispatch(actions.planProjects.all())), [plan.plan]);

    if (!asset.asset || !plan.plan) return <span>{'#asset or plan not in store'}</span>;

    if (allProjects.fetching)
        return (
            <div className={classes.root}>
                <Skeleton variant='rect' height={100} />
                <Skeleton variant='rect' height={100} />
            </div>
        );

    return (
        <div className={classes.root}>
            {allProjects.projects.length === 0 && <span>{t('no-project')}</span>}
            {allProjects.projects.map(project => (
                <ProjectCard key={project.id} name={asset.asset!.name} project={project} download />
            ))}
        </div>
    );
};
